import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  coverImage: string;
  author: string;
  date: string;
  readTime: string;
  views: number;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  author,
  date,
  readTime,
  views,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200/60">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/40 to-transparent"></div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views.toLocaleString()}
            </span>
            <span>{date}</span>
          </div>
        </div>
      </div>
    </article>
  );
}